export default {
	isRequired: (value, errorMessage = false) => {
		if (!value || value === undefined || value === null) {
			return errorMessage || 'This field is required'
		}
		else if (String(value).trim() === '') {
			return errorMessage || 'This field is required'
		}
		return true
	},
	isEmail: value => {
		return !(/\S+@\S+\.\S+/).test(value) ? 'Enter a valid email address' : true
	},
	isPhone: value => {
		return !(/^[0]{1}[7-9]{1}[0-9]{9}$/).test(value.trim()) ? 'Enter a valid phone number (Ex. 08092480081)' : true
	},
	isNumber: (value, errorMessage) => {
		if (value.trim() === '' || isNaN(value) || value < 1) {
			return errorMessage || 'This field must be a number'
		}
		return true
	}
}
